/**
 * @generated SignedSource<<4c330eecc5e1bd35632a84504f504bdd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type name_projectVersions_NameCell_jiraVersion$data = {
  readonly name: string;
  readonly versionId: string;
  readonly " $fragmentType": "name_projectVersions_NameCell_jiraVersion";
};
export type name_projectVersions_NameCell_jiraVersion$key = {
  readonly " $data"?: name_projectVersions_NameCell_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"name_projectVersions_NameCell_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "name_projectVersions_NameCell_jiraVersion",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "versionId"
      },
      "action": "THROW",
      "path": "versionId"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW",
      "path": "name"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "ff19770b46145efacc61452e92184dda";

export default node;
